export const UNKNOWN_ERROR_MESSAGE = 'UNKNOWN_ERROR';
export const PASS_ERROR_MESSAGE = 'PASS_ERROR';
